import React from 'react'
import { array, func, bool } from 'prop-types'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'

import * as spacing from 'styles/spacing'
import { white, black } from 'styles/colors'
import { media } from 'styles/media'
import { square, animationTime, animationCurve } from 'styles/global'

const Item = styled.div`
  position: relative;
  cursor: pointer;

  & + & {
    margin-left: ${spacing.medium};
  }
`

const Color = styled.div`
  position: relative;
  border-radius: 50%;
  background-color: ${props => props.hex};
  ${square('20px')};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid ${rgba(black, 0.1)};
  }

  &:before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 2px solid ${props => (props.isDark ? white : black)};
    border-radius: 50%;
    opacity: 0;
    visibility: hidden;
    transition: all ${animationTime} ${animationCurve};

    ${props =>
      props.active &&
      css`
        opacity: 1;
        visibility: visible;
      `}
  }

  ${media.medium`
    ${square('24px')};
  `};
`

const SwatchList = ({ swatches, onClick, isDark }) => (
  <>
    {swatches.map((swatch, i) => (
      <>
        {swatch.availableForSale && (
          <Item key={i} data-tip={`${swatch.prettyName} ${!swatch.availableForSale ? ' - Unavailable' : ''}`}>
            <Color
              isDark={isDark}
              active={swatch.active}
              hex={swatch.hex}
              onClick={() => {
                onClick(i)
              }}
            />
          </Item>
        )}
      </>
    ))}
  </>
)

SwatchList.propTypes = {
  swatches: array.isRequired,
  onClick: func.isRequired,
  isDark: bool
}

export default SwatchList
